// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Modal {\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n\r\n    background-color: var(--shadow-chio-color);\r\n    z-index: 1001;\r\n}", ""]);
// Exports
module.exports = exports;
